import {Style, Circle as CircleStyle, Fill, Stroke} from 'ol/style';
import React from 'react';

export const mapStyles = [
	new Style({
		image: new CircleStyle({
			radius: 0,
			fill: new Fill({color: '#03a9f4'}),
			stroke: new Stroke({color: '#ffffff', width: 1}),
		}),
	}),
	new Style({
		image: new CircleStyle({
			radius: 6,
			fill: new Fill({color: '#03a9f4'}),
			stroke: new Stroke({color: '#ffffff', width: 1}),
		}),
	}),
	new Style({
		image: new CircleStyle({
			radius: 8,
			fill: new Fill({color: '#03a9f4'}),
			stroke: new Stroke({color: '#ffffff', width: 1}),
		}),
	}),
	new Style({
		image: new CircleStyle({
			radius: 16,
			fill: new Fill({color: '#03a9f4'}),
			stroke: new Stroke({color: '#ffffff', width: 2}),
		}),
	}),
	new Style({
		image: new CircleStyle({
			radius: 32,
			fill: new Fill({color: '#03a9f4'}),
			stroke: new Stroke({color: '#ffffff', width: 2}),
		}),
	})
]

export function StyleTglBtn(props) {
	return (
		<button 
		    className='ol-custom ol-control' 
		    id='style-tgl-btn' 
		    style={{top: 8, left: document.getElementById('mapContainer') ? document.getElementById('mapContainer').clientWidth - 40 : 8, width: 32, height: 32}} 
		    onClick={props.tglStyle}>
			{'S' + props.style}
		</button>
	);
}

export function MapObsPopup(props) {
	function closeClick(e) {
		props.proceedDetails(1);
	}

	return (
		<div
		    ref={props.mapPopRef}
		    id="obs-popup"
		    className="overlay-container"
		    onClick={closeClick} 
		    style={{backgroundColor: 'white', padding: 8, border: '2px solid #cccccc', borderRadius: 10, boxShadow: '2px 4px #888888'}}
		>
			{props.num > 1 ? <div className="overlay-text" id="obs-pos">{props.pos + 1 + ' / ' + props.num}</div> : null}
			<div className="overlay-text" id="obs-species" />
			<div className="overlay-text" id="obs-date" />
			<div className="overlay-text" id="obs-address" />
		</div>
	);
}
